export const FILTER_STATUS_FALSE = 'false';
export const FILTER_STATUS_TRUE = 'true';

export const FILTER_INITIAL_STATE = {
    status: FILTER_STATUS_FALSE
};
